import React from 'react'
import ReactDOM from 'react-dom/client'
import '@/app/index.scss'
import App from '@/app/App'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { Main } from '@/page/Main/Main.jsx'
import { Desktop } from './page/Desktop/Main/Desktop'
import { DistributorPage } from './page/Desktop/pages/DistributorPage/DistributorPage'
import "./i18n.js"
require('sass')

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                path: '/',
                element: <Main />,
                children: [
                    {
                        path: '/',
                        element: <Desktop />,
                        children: [
                            {
                                path: '/',
                                element: <DistributorPage />,
                            },
                        ],
                    },
                ],
            },
        ],
    },
])

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<RouterProvider router={router} />)
